import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import Card from 'broker/views/components/Card'
import CardRow from 'broker/views/components/CardRow'
import RawCardSection from 'broker/views/components/CardSection'
import RecentActivity from 'broker/views/components/Deprecating/RecentActivity'

import { selectAccountLoading } from 'broker/selectors/account'

const CardSection = connect(createStructuredSelector({
  loading: selectAccountLoading
}))(RawCardSection)


class BrokerActivityCard extends Component {
  render() {
    return <Card>
      <CardSection title="Activity" nopad>
        <CardRow>
          <RecentActivity />
        </CardRow>
      </CardSection>
    </Card>
  }
}

export default BrokerActivityCard
